<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.cs
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero 
        span 2
      h1 Instrumentos de recolección de información
   
    
    p.mb-5 Para abordar este tema, es necesario mencionar que en todo diagnóstico el fin es identificar y reconocer un problema específico, luego de definir las áreas vinculadas y de recopilar la información pertinente y relacionada con el aspecto a tratar, considerándose el diagnóstico una investigación. Todo plan de trabajo contiene tres elementos esenciales, de acuerdo con Gallardo (1999): método, técnica e instrumentos.

  .container.bg-white.px-md-5.px-3.py-2.container-top.fondo-1.mb-0.cs.mg-top-1
    .titulo-sexto.color-acento-contenido.mb-5(data-aos="zoom-in-right")
      h5  Figura 6.
      span  Elementos de un plan de trabajo 

    .row.justify-content-around.align-items-center(data-aos="zoom-in-right")
      .col-md-6.col-lg.mb-5.mb-lg-0
        .tarjeta-avatar.center
          img(src='@/assets/curso/images/tema2/icon_1.svg' alt='', style="width:170px")
          .tarjeta.mx-4
            .p-4
              h4.text-center.mb-3 Método
              p.text-center.mb-0 El método es el procedimiento general.

      .col-md-6.col-lg.mb-5.mb-lg-0
        .tarjeta-avatar
          img(src='@/assets/curso/images/tema2/icon_2.svg', style="width:170px;")
          .tarjeta
            .p-4
              h4.text-center.mb-3 Técnica
              p.text-center.mb-0 La técnica se refiere a las maneras de abordar distintas actividades de forma estandarizada.


      .col-md-6.col-lg.mb-5.mb-lg-0
        .tarjeta-avatar
          img(src='@/assets/curso/images/tema2/icon_3.svg' , style="width:170px;")
          .tarjeta
            .p-4
              h4.text-center.mb-3  Instrumentos
              p.text-center.mb-0 Los instrumentos son los mecanismos  para recoger la información de forma direccionada y organizada.

      .row.align-items-center.justify-content-center
        .col-lg-10
          .jumbotron.p-4
            p.mb-0 <b>La función primordial de los instrumentos de recolección de información es el registro de los fenómenos empíricos,</b> quedando registrados a través de la aplicación del instrumento utilizado, el cual permite obtener información precisa, si ha sido diseñado de manera adecuada y pertinente.
    
  .container.bg-white.p-md-5.p-4.container-bottom.mt-0.cs.mb-0

    p.mb-5 La recolección de la información debe realizarse haciendo uso de un proceso planeado paso a paso, para que de manera estructurada y coherente se obtengan resultados que coadyuven favorablemente al logro de los objetivos planteados. La búsqueda de la información se realiza basada en elementos del punto focal o situación objeto de estudio, el planteamiento de preguntas relevantes, las variables intervinientes en el proceso y los indicadores que permiten operacionalizarlas. 


    .row.justify-content-center.align-items-center
      .col-lg-12
        .bloque-texto-g.color-custom-2.p-3.p-sm-4.p-md-5.mb-5.d-none.d-lg-block
          .bloque-texto-g__img(data-aos="fade-right")(
            :style="{'background-image': `url(${require('@/assets/curso/images/tema2/img_2.png')})`}"
          )
          .bloque-texto-g__texto.p-5.m-right(data-aos="fade-left")
            p.mb-0 Al diseñar los instrumentos de recolección de información, es recomendable realizar su aplicación con el fin de evaluar su pertinencia a través de una prueba piloto, la cual es fundamental, porque allí se califica el personal en esta labor, se evalúa  el desarrollo de actividades ya en campo, y posteriormente, sugerir algunas modificaciones antes de realizar el estudio en su totalidad.

    .bloque-texto-a.color-custom-9.p-md-0.mb-5.d-block.d-lg-none
      .row.m-4.align-items-center.justify-content-between
        .col-lg-9(data-aos="fade-right")
          .bloque-texto-a__texto.p-5.my-5
            p Al diseñar los instrumentos de recolección de información, es recomendable realizar su aplicación con el fin de evaluar su pertinencia a través de una prueba piloto, la cual es fundamental, porque allí se califica el personal en esta labor, se evalúa  el desarrollo de actividades ya en campo, y posteriormente, sugerir algunas modificaciones antes de realizar el estudio en su totalidad.
        .col-lg-3.mb-3.mb-lg-0(data-aos="fade-left")
          figure
            img(src='@/assets/curso/images/tema2/img_2.png' alt='', style="width:400px; display:block; margin:-1rem 0 ;").mb-3
    .row.justify-content-center.align-items-center
      .col-lg-12
        p.mb-5 Simultáneamente, es recomendable diseñar y estructurar el manejo de la información a partir de la elaboración de un diagrama del procesamiento de esta, ya que el cúmulo de información que se espera obtener es bastante. Este debe incluir un esquema de control de calidad para validar la correlación entre los datos procesados y los datos recolectados, que contemple el proceso a llevar a cabo para definir la veracidad de los mismos  por el encuestador, observador o entrevistador.

    .row.align-items-center.justify-content-center.mb-3
      .col-lg-7(data-aos="fade-right") 
        p.mb-3 La información recolectada debe cumplir con dos características: confiabilidad, considerada como la capacidad del instrumento para arrojar datos o mediciones que correspondan a la realidad que se pretende conocer; y  validez, definida como la propiedad del instrumento para medir u observar lo que se pretende de la investigación. Esta condición es fundamental para obtener la confiabilidad. La validez se relaciona con la verosimilitud, o más precisamente, con la correspondencia entre el modelo teórico construido en la investigación y la realidad empírica. Se habla de validez interna o credibilidad para referirse a la congruencia entre las observaciones realizadas en el trabajo de campo y la realidad tal como la perciben los sujetos.

        p.mb-0 En los últimos tiempos, varias disciplinas científicas han incorporado la triangulación como uno de los procedimientos para asegurar la validez y la confiabilidad de la información que utilizan. Esto se ha hecho creciente en las ciencias sociales, las ciencias biológicas, en las disciplinas tecnológicas y en algunas de las ciencias naturales. La triangulación no se reduce a lo metodológico y, según la conocida clasificación de Denzin, habría cuatro tipos de triangulación.
      .col-lg-5(data-aos="fade-left") 
        img.mt-3(src='@/assets/curso/images/tema2/img_3.png')

    h3 Tipos de triangulación
    .row.justify-content-evenly.align-items-center.p-2
      .col-lg-6(data-aos="fade-right")
        img(src='@/assets/curso/images/tema2/img_11.png').mb-3
      .col-12.col-lg-6.mb-4.p-0.p-md-5(data-aos="fade-left")
        LineaTiempoD.color-secundario.especial
          .row(titulo='Triangulación de datos' numero='1')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  Consiste en realizar una comparación de datos que provienen de distintas fuentes y están referidos a un mismo tema o fenómeno. Presenta tres subtipos: a) de tiempo; b) de espacio; y c) de personas. Estas últimas pueden ser analizadas en tres niveles: agregado, interactivo y colectivo.

          .row(titulo='Triangulación de teorías' numero='2')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  Técnica que aplica diferentes modelos teóricos a un consolidado de información o a un lineamiento conceptual. Se realiza con el fin de integrar métodos, teorías y datos condensados que se relacionen con la realidad.
          
          .row(titulo='Triangulación de investigadores' numero='3')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  Utiliza las observaciones recogidas acerca de una misma circunstancia o entorno, las cuales son presentadas con el fin de realizar una confrontación entre colegas, lo cual permite encontrar categorías consensuadas, precisar las interpretaciones acerca de los datos y garantizar la calidad.

          .row(titulo='Triangulación metodológica' numero='4')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  Proceso que utiliza diversas técnicas e instrumentos, que provienen de un método particular, relacionadas con el mismo objeto o fin del estudio; también se puede utilizar una combinación de técnicas (la observación, la entrevista, el análisis de documentos, etc.), logrando una mayor solidez en la información y reduciendo el sesgo particular de los participantes vinculados.

    
    Separador 

    #t_2_1.titulo-segundo
      .h2 2.1 Tipos
    
    p.mb-3 Existen diferentes instrumentos para recopilar información que son usados según su propósito y de acuerdo con el diseño que se realice, el cual debe ser validado y puesto a prueba para comprobar su pertinencia y eficiencia en cuanto al logro del objetivo propuesto. Se considera que la clasificación de los instrumentos para recolectar información es determinada según el tipo de información a recolectar, es decir, si es cuantitativa o cualitativa.

    AcordionA.mb-5(tipo="a" clase-tarjeta="tarjeta tarjeta--gris")(data-aos="fade-up")
      div(titulo="Instrumentos de recolección de información cualitativa")
        .row.align-items-star.justify-content-center.p-4
          .col-lg-6
            img(src='@/assets/curso/images/tema2/img_4.png').mb-3
          .col-lg-6
            p.mb-3 Los instrumentos de recolección de información cualitativa son necesarios debido a la existencia de la investigación cualitativa basada en la comparación. Este tipo de instrumentos son utilizados en proyectos donde se requiere demostrar una teoría, donde existe una variable dependiente y una independiente, es decir, proyectos de tipo social o que analizan el comportamiento humano en un entorno determinado indiferente del sector al que corresponda. 

            p.mb-3 Los instrumentos de recolección de información cualitativa son:
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Entrevistas.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Observación participante.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Análisis documental.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Autorreportaje.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Categorización.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Triangulación y Teoría fundamentada. Perspectivas de diferentes autores.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Documentos de archivo y fuentes gubernamentales.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Comunidades <i>online.</i> 
          
         
      div(titulo="Instrumentos de recolección de información cuantitativa")
        .row.align-items-star.justify-content-center.p-4
          .col-lg-5
            img(src='@/assets/curso/images/tema2/img_5.png').mb-3
          .col-lg-7
            p.mb-3 Están orientados a obtener datos concretos y numéricos sobre la variable, situación o problema objeto de estudio.
            .list
              .list__item
                .list__item__icon
                  img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
              .list__txt    
                p.m-top Entrevistas.
            .list
              .list__item
                .list__item__icon
                  img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
              .list__txt    
                p.m-top Cuestionario físico y <i>online.</i> 
            .list
              .list__item
                .list__item__icon
                  img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
              .list__txt    
                p.m-top Observación cuantitativa.
            .list
              .list__item
                .list__item__icon
                  img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
              .list__txt    
                p.m-top Documentos de archivo y fuentes gubernamentales.
            .list
              .list__item
                .list__item__icon
                  img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
              .list__txt    
                p.m-top <i>Focus group</i> presenciales y <i>online.</i> 
            .list
              .list__item
                .list__item__icon
                  img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
              .list__txt    
                p.m-top Triangulación y Teoría fundamentada. Perspectivas de diferentes autores.
            .list
              .list__item
                .list__item__icon
                  img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
              .list__txt    
                p.m-top Experimentos de laboratorio.

    Separador 

    #t_2_2.titulo-segundo
      .h2 2.2 Técnicas   

  .container.bg-white.px-md-5.px-3.py-2.container-top.fondo-1.mb-0.mg-top-1          
    .row.align-items-center.justify-content-center.mb-5
      .col-lg-7(data-aos="fade-left") 
        img.mt-3(src='@/assets/curso/images/tema2/img_12.png').mb-3
      .col-lg-5(data-aos="fade-right") 
        p.mb-3 Las técnicas de recolección de información corresponden a los procedimientos elegidos para adelantar una investigación de cualquier orden, con el fin de garantizar que la técnica elegida aporta al cumplimiento del objetivo de la investigación. Las técnicas más conocidas son:
        .list
          .list__item
            .list__item__icon
              img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
          .list__txt    
            p.m-top Encuesta.
        .list
          .list__item
            .list__item__icon
              img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
          .list__txt    
            p.m-top Observación.
        .list
          .list__item
            .list__item__icon
              img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
          .list__txt    
            p.m-top Entrevista.
        .list
          .list__item
            .list__item__icon
              img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
          .list__txt    
            p.m-top Recopilación documental, revisión documental o análisis documental.
        .list
          .list__item
            .list__item__icon
              img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
          .list__txt    
            p.m-top Autorreportaje. 
        .list
          .list__item
            .list__item__icon
              img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
          .list__txt    
            p.m-top Triangulación y teoría fundamentada. 
        .list
          .list__item
            .list__item__icon
              img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
          .list__txt    
            p.m-top Comunidades <i>online.</i> 
          
  .container.bg-white.p-md-5.p-4.container-bottom.mt-0.mg-top-1
      
    .row.aling
      .col-lg-12(data-aos="zoom-in-down")
        .cajon.color-custom-1.p-4.mb-4
          .row.justify-content-around.align-items-center
            .col-lg-12
              .row.justify-content-between.align-items-center
                .col.mb-3.mb-sm-0
                  p.mb-0 Ahora bien, de acuerdo con la técnica a implementar, se determina el instrumento de recolección de información a usar. Estos son diseñados de acuerdo con el objetivo a estudiar, el cual parte del problema que origina la investigación; por esta razón, en este apartado, se incluyen los instrumentos en cada tipología, con la claridad de que su diseño y aplicación deben ser acordes con la información que se espera obtener. A continuación, se presentan cada uno de ellos.

    .row.align-items-center.align-items-center.bg-rosa.mb-3
      .col-lg-12
        PasosB.color-acento-botones.py-5.px-5
          .row(titulo="")
            .col-md-6.mb-4.mb-md-0
              h5 Encuesta
              p La encuesta es un instrumento de investigación que busca describir, analizar y establecer las relaciones entre variables en poblaciones o grupos particulares. Es propicia cuando se desea obtener el conocimiento colectivo o de tipos de participantes, como instituciones o fenómenos. Se utiliza en procesos en que se requiere conocer un asunto u objetivo de investigación de manera amplia, por lo que se convierte en el instrumento más apto para alcanzar una comunidad. Pueden ser orales o escritas.
          
            .col-md-6
              figure
                img(src='@/assets/curso/images/tema2/img_13.png', alt='Texto que describa la imagen')


          .row(titulo="")
            .col-md-6.mb-4.mb-md-0
              h5 Observación
              p.mb-3  Técnica de recolección de información que consiste en la inspección y estudio de los hechos u objeto de investigación, tal como ocurren en la realidad, a través del uso de los sentidos (con o sin ayuda de soportes tecnológicos), de acuerdo con los requerimientos de estudio y a partir de las categorías perceptivas definidas desde las teorías científicas que apoyan la investigación. Los tipos de técnicas de observación existentes son:

              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Directa.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Indirecta: ocurre cuando el acto de observación requiere de la utilización de instrumentos apropiados para la captación de las características del fenómeno. La dependencia del observador de los instrumentos es fundamental en este tipo de observación.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top La participante: atañe a la observación que realiza el investigador de manera cercana a la realidad.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top No participante: corresponde a la observación que se realiza por parte del investigador sin acercarse a la realidad.
                        
            .col-md-6
              figure
                img(src='@/assets/curso/images/tema2/img_14.png', alt='Texto que describa la imagen')


          .row(titulo="")
            .col-md-6.mb-4.mb-md-0
              h5 Entrevistas
              p.mb-3  Es una herramienta principalmente para la recolección de datos cualitativos, aunque se precisa que, de acuerdo con el diseño que se realice, puede ser utilizada para la recolección de datos cuantitativos. Es de uso cotidiano como instrumento para recopilar información debido a su flexibilidad. Las interacciones que se generan en una entrevista pueden presentarse de forma estructurada o semiestructurada para generar ideas y conceptos.

              p.mb-3 En el diseño de la entrevista, se deben tener en cuenta aspectos como la exhaustividad, el tacto, la precisión, la exactitud y la confidencialidad. Las entrevistas requieren habilidades especializadas por parte del entrevistador, que tendrá que tener una buena relación con el entrevistado para garantizar que realmente se recolectan y transcriban eficazmente un conjunto de datos cualitativos muy detallados y válidos.
            .col-md-6
              figure
                img(src='@/assets/curso/images/tema2/img_15.png', alt='Texto que describa la imagen')
        
            .row
              p.my-3 Los tipos de entrevista son: estructurada o formal, no estructurada  o informal, semiestructurada. También se pueden clasificar en: entrevista individual o entrevista grupal o <i>focus group.</i>

              p.mb-3 En las entrevistas, se usan cuestionarios para la recolección de información, ya sea cualitativa o cuantitativa. Su elaboración debe ser cuidadosa y profesional, de manera que las preguntas no influyan en la respuesta que se espera recibir. 

              p.mb-0 Este tipo de instrumentos se diseña con preguntas abiertas, donde la respuesta no está condicionada sino que se tiene la facilidad de responder a criterio propio y con su propio lenguaje. También se puede elaborar con preguntas cerradas si el objeto de aplicación del instrumento requiere respuestas precisas, que develen la causa de una situación o raíz de un problema.

          .row(titulo="")
            .col-md-6.mb-4.mb-md-0
              h5 Recopilación/revisión/análisis documental
              p.mb-3 El fundamento de una investigación se origina en la revisión o análisis de fuentes bibliográficas, las cuales pueden ser personales, como testimonios, entrevistas grupales, institucionales, formales o informales. En estas fuentes, se encuentran diferentes tipos de información de incalculable valor, que pueden consolidarse como piezas claves para el desarrollo del diagnóstico o investigación. Para realizar el análisis documental, es necesario:

              p.mb-0 Realizar un inventario de documentos existentes y disponibles.
              p.mb-0 Clasificar los documentos identificados.
              p.mb-0 Seleccionar los documentos más pertinentes para el propósito u objeto de la investigación.
              p.mb-0 Leer a profundidad los documentos seleccionados, extrayendo de ellos, a través del análisis, patrones, tendencias, convergencias y contradicciones que se vayan identificando.
              p.mb-3 Cruzar la información encontrada a través de la lectura y compararla en aspectos o hallazgos previamente realizados, lo que aportará al desarrollo de una síntesis sobre la realidad estudiada.
              p.mb-0 El tipo de información base para realizar el análisis documental son escritos, documentos numéricos y documentos cartográficos.
            .col-md-6
              figure
                img(src='@/assets/curso/images/tema2/img_17.png', alt='Texto que describa la imagen')

          .row(titulo="")
            .col-md-6.mb-4.mb-md-0
              h5 <i>Focus group</i>
              p Es una herramienta o instrumento cualitativo de recolección de datos. Consiste en realizar una entrevista en grupo, con el objetivo de recoger información sobre un número específico de preguntas. Es muy útil para recoger información de manera inmediata y espontánea, bajo la instrucción de un moderador, el cual socializa la herramienta y presenta el objetivo de su aplicación.
          
            .col-md-6
              figure
                img(src='@/assets/curso/images/tema2/img_18.png', alt='Texto que describa la imagen')

          .row(titulo="")
            .col-md-6.mb-4.mb-md-0
              h5 Autorreportaje
              p Es una técnica donde el mismo informante reportará su situación o experiencia solicitada por el investigador. Para desarrollar el autorreportaje, es necesario elaborar un guion con preguntas puntuales y fundamentales relacionadas con el suceso o vivencia.
          
            .col-md-6
              figure
                img(src='@/assets/curso/images/tema2/img_19.png', alt='Texto que describa la imagen')

          .row(titulo="")
            .col-md-6.mb-4.mb-md-0
              h5 Categorización. Triangulación y teoría fundamentada
              p.mb-3 Consiste en realizar un proceso a través del cual se busca reducir la información de la investigación, con el fin de describirla de manera conceptual y que esta responda a una estructura sistemática e inteligible para las personas y que, a su vez, sea significativa. Para que esta información conserve su carácter en este proceso de categorización, es necesario que el investigador conserve los temas tratados en la investigación, ya que esto permite mantener los resultados de la investigación encontrados por su autor.
              p.mb-3 También es pertinente mencionar que esta herramienta es un proceso cognitivo complejo de clasificación según las semejanzas y diferencias encontradas, que responden a unos criterios previamente determinados, es decir, la agrupación de información, de acuerdo con sus características, en capítulos, apartados o conjuntos y subconjuntos a los que se les debe asignar nombre. Las categorías se dividen en tres clases: 
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Deductivas: se fundamentan en el marco conceptual, las preguntas y objetivos de investigación.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Inductivas: emergen de los datos con base en el examen de patrones y recurrencias.
              .list
                .list__item
                  .list__item__icon
                    img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
                .list__txt    
                  p.m-top Abductivas: descubrimiento de eventos anómalos o sorpresivos sobre los que se crean conceptos.

            .col-md-6
              figure
                img(src='@/assets/curso/images/tema2/img_21.png', alt='Texto que describa la imagen')

          .row(titulo="")
            .col-md-6.mb-4.mb-md-0
              h5 Triangulación
              p.mb-3 Cumple con la función de validar la información obtenida  y consiste en el uso de dos o más aproximaciones en el análisis de un mismo grupo de datos, con el propósito de realizar su validación. Se lleva a cabo comparando el resultado del análisis de datos, usando diferentes técnicas de análisis cualitativo para evaluar en forma similar los resultados disponibles. Sirve para identificar patrones similares y así verificar los hallazgos. Existen los siguientes tipos de triangulación:

              p.mb-3 La triangulación teórica consiste en el uso de diferentes perspectivas o diferentes tópicos esenciales en la información analizada.
          
            .col-md-6
              figure
                img(src='@/assets/curso/images/tema2/img_22.png', alt='Texto que describa la imagen')

            .row
              p.mt-3 La triangulación metodológica puede implicar una triangulación dentro de métodos que consiste en la combinación de dos o más resultados de recolecciones de datos con similitudes aproximadas en el mismo estudio, es decir, un mismo aspecto estudiado a partir de dos instrumentos de recolección de información  diferentes. Cada estudio se debe codificar y analizar separadamente, para luego compararlos con el fin de validar los hallazgos.

          .row(titulo="")
            .col-md-6.mb-4.mb-md-0
              h5 Comunidades <i>online</i>
              p.mb-3 Llamadas también <i>Insight Community</i>, herramienta que utilizan las organizaciones que poseen su marca con el fin de realizar investigación con un grupo de personas de interés y así conocer sus comentarios, observaciones y sugerencias, por lo cual es necesario mantener una audiencia en contacto a través de foros, encuestas y sondeos.

              p.mb-0 Este instrumento es muy valorado por las empresas, pues a través de él las organizaciones encuentran información inmediata, lo cual les permite acceder al amplio conocimiento que poseen los participantes.
          
            .col-md-6
              figure
                img(src='@/assets/curso/images/tema2/img_23.png', alt='Texto que describa la imagen')


        
    p.mb-5 Las comunidades <i>online</i>  son una inversión productiva para las empresas porque generan un espacio adecuado para recolectar información al instante y generar relaciones más estrechas que logran llegar a la fidelidad. Existen diferentes tipos de comunidades <i>online.</i> 

    .row.mb-3
      .col-lg-4(data-aos="fade-left") 
        .jumbotron-1.mb-3.p-4
          h4 Comunidades de marca
          p.mb-0 En este tipo de comunidad, se vinculan personas que aman la marca y quieren contribuir con sus aportes para su retroalimentación. Estos tipos de participantes son considerados la población objetivo, son leales, lo que hace que sus aportes sean valiosos porque corresponden a la realidad debido a su sinceridad.
        .jumbotron-2.p-4
          h4 Comunidades genéricas
          p.mb-0 Están integradas por personas con diversos perfiles, que participan en diferentes áreas, dependiendo del perfil profesional o personal que requiera la investigación. Aquí se utilizan encuestas para perfilar y segmentar los participantes en estudios específicos.
      .col-lg-4(data-aos="fade-left") 
          img.mt-3(src='@/assets/curso/images/tema2/img_7.svg').mb-3
      .col-lg-4(data-aos="fade-left") 
        .jumbotron-2.mb-3.p-4
          h4 Comunidades temáticas o de nichos
          p.mb-0 Son comunidades que buscan información de manera gratuita, por tanto, no necesariamente pertenecen a una marca, sino que su enfoque son temas específicos, atractivos para ciertos públicos, los cuales pueden ser ofrecidos a industrias interesadas en ese tema especialmente.
        .jumbotron-1.p-4
          h4 Comunidades de clientes
          p.mb-0 Son clientes de la marca que participan en diferentes actividades, como fotos o lluvias de ideas sobre nuevos productos y servicios.

    h3.mb-3 Técnica e instrumentos de recolección de información
    p.mb-3 El siguiente gráfico ejemplifica de forma genérica cómo seleccionar el instrumento de acuerdo con la técnica a implementar.  
    
    .row.align-items-center.justify-content-center.mb-5
      .col-lg-8
        .titulo-sexto.color-acento-contenido.mb-3(data-aos="zoom-in-right")
          h5 Figura 8
          span Técnica e instrumentos de recolección de información.
        img.mt-3(src='@/assets/curso/images/tema2/fig_2.svg')(data-aos="zoom-in-right")

    Separador

    #t_2_3.titulo-segundo
      .h2 2.3 Grupos de interés
    
    p.mb-3 Corresponden a grupos de personas dentro de una organización que tienen objetivos propios, ellos son los accionistas o inversionistas, directivos y empleados, que mantienen un vínculo con la empresa como resultado del planteamiento de objetivos estratégicos, los cuales inciden en la labor que cada uno desempeña y en los objetivos que deben alcanzar desde su puesto de trabajo; de ahí la importancia de gestionarlos de manera estratégica y proactiva.

    p.mb-5 En estos grupos de interés, además de llegar a consensos, se delegan funciones, se asignan responsabilidades individuales y colectivas cuyo resultado va a incidir en el desempeño organizacional y en el logro de los objetivos empresariales.
   
    .row.justify-content-center.align-items-center
      .col-lg-12
        .bloque-texto-g.color-custom-2.p-3.p-sm-4.p-md-5.mb-5.d-none.d-lg-block
          .bloque-texto-g__img(data-aos="fade-right")(
            :style="{'background-image': `url(${require('@/assets/curso/images/tema2/img_8.png')})`}"
          )
          .bloque-texto-g__texto.p-5.m-right(data-aos="fade-left")
            p.mb-0 Sin desconocer que cada individuo tiene una formación, experiencia, habilidades, destrezas, así como debilidades, se deben tratar de manera adecuada para aportar a la consolidación del equipo de trabajo y de la organización; pero si ellos se esconden o se ignoran, pueden causar daños irreparables a la misma en todos sus ámbitos, siendo la negociación el elemento que brinda el equilibrio requerido en la organización.

    .bloque-texto-a.color-custom-9.p-md-0.mb-5.d-block.d-lg-none
      .row.m-4.align-items-center.justify-content-between
        .col-lg-9(data-aos="fade-right")
          .bloque-texto-a__texto.p-5.my-5
            p Sin desconocer que cada individuo tiene una formación, experiencia, habilidades, destrezas, así como debilidades, se deben tratar de manera adecuada para aportar a la consolidación del equipo de trabajo y de la organización; pero si ellos se esconden o se ignoran, pueden causar daños irreparables a la misma en todos sus ámbitos, siendo la negociación el elemento que brinda el equilibrio requerido en la organización.
        .col-lg-3.mb-3.mb-lg-0(data-aos="fade-left")
          figure
            img(src='@/assets/curso/images/tema2/img_8.png' alt='', style="width:400px; display:block; margin:-1rem 0 ;").mb-3

    p.mb-3 Los grupos de interés se clasifican de acuerdo con su relevancia y el posible impacto que tienen dentro de la organización. De acuerdo con este criterio, tienen las siguientes características:
    
    h5 Características de los grupos de interés o stakeholders
    .row.justify-content-evenly.align-items-center
      .col-12.col-lg-6.mb-4.md-5(data-aos="fade-left")
        LineaTiempoD.color-secundario.especial
          .row(titulo='Legitimidad' numero='1')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-0  Es la obligatoriedad que tienen los grupos de interés de cumplir con normas, leyes, reglamentos, procesos y procedimientos en un sistema social o es la implicación de cumplir con el reglamento de trabajo, las normas legales y las políticas organizacionales.
           

          .row(titulo='Impacto social' numero='2')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0

                p - Fomentan el desarrollo humano.
                p - Desarrollan el liderazgo, el trabajo en equipo y el espíritu empresarial.
                p - Promueven la participación de la mujer, la práctica de la democracia y fomentan la igualdad.
                p - Proporcionan un ambiente colaborativo, solidario y de unidad.
          
          .row(titulo='Sociedad Anónima' numero='3')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3 Esta sociedad se forma por la unión de mínimo cinco socios, sin límite o máximo impuesto. Se constituye cuando los aportes de capital se realizan mediante la compra de acciones y su responsabilidad corresponde al monto o valor de sus aportes.
          .row(titulo='Poder' numero='4')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p Es la posibilidad real de tomar decisiones, determinar el rumbo de la organización, así como sobre los demás grupos existentes, y de hacer cumplir los objetivos propios. Esta característica se presenta por su posición jerárquica, así como por la capacidad de influencia.
          
          .row(titulo='Liderazgo' numero='5')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
  
                p.mb-0  Busca influir en el equipo de trabajo o demás grupos de interés presentes en la organización, para el cumplimiento de los objetivos según la importancia o impacto para alcanzar los mismos.
      .col-lg-6(data-aos="fade-right")
        img(src='@/assets/curso/images/tema2/img_24.png')

    
    .row.aling.my-3  
      .col-lg-12(data-aos="zoom-in-down")
        .cajon.color-custom-10.p-4.mb-4.p-4
          .row.justify-content-around.align-items-center
            .col-lg-12
              .row.justify-content-between.align-items-center
                .col.mb-3.mb-sm-0
                  p.mb-0 Los grupos de interés son identificados de acuerdo con la prioridad que tienen los objetivos asociados a los grupos más importantes. Es una misión de la dirección buscar el equilibrio entre los objetivos de los diferentes grupos presentes en la empresa, lo cual solo puede alcanzarse mediante la negociación, al fijar objetivos que integren los de todos, con el fin de otorgar la capacidad de tomar decisiones y especialmente de participar. Los criterios para reconocer grupos de interés son:
    .row.align-items-center.justify-content-center.mb-3
      .col-lg-5(data-aos="fade-right")
        .list
          .list__item
            .list__item__icon
              img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
          .list__txt    
            p.m-top Si el grupo tiene poder, es legítimo y además influye en el logro de objetivos. Su función en la organización es crucial y determinante
        .list
          .list__item
            .list__item__icon
              img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
          .list__txt    
            p.m-top Se deben considerar grupos de interés aquellos que aparecen de manera latente, aunque su relevancia sea escasa, con el fin de promover la participación como parte de la motivación grupal e individual de sus participantes.
        .list
          .list__item
            .list__item__icon
              img.img-a(src="@/assets/curso/images/tema2/folder.svg").img-fluid  
          .list__txt    
            p.m-top Nacen de forma colectiva porque se identifican en sus intereses y comparten una misma motivación. Este tipo de grupo de interés permanecerá hasta lograr su objetivo.

        p.mb-0 Los grupos de interés también se definen de acuerdo con los siguientes aspectos.
      .col-lg-5(data-aos="fade-left") 
        img.mt-3(src='@/assets/curso/images/tema2/img_9.png')
    
    .row.justify-content-evenly.align-items-center
      .col-lg-6(data-aos="fade-right")
        img(src='@/assets/curso/images/tema2/img_25.svg').mb-3
      .col-12.col-lg-6.mb-4.md-5(data-aos="fade-left")
        LineaTiempoD.color-secundario.especial
          .row(titulo='Grupos de interés externos' numero='1')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  Mantienen algún vínculo con la empresa. En este grupo, se encuentran los clientes, proveedores, entidades financieras, comunidad local, organizaciones gremiales, entre otros.

          .row(titulo='Grupos de interés primarios' numero='2')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  Pueden identificarse por el tipo de relación que mantienen con la empresa, como los contratistas, por ejemplo.

          .row(titulo='Grupos de interés internos' numero='3')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  Pertenecen a la organización o tienen participación en el desarrollo empresarial; en este grupo, están los accionistas, directivos y colaboradores.


          .row(titulo='Grupos de interés secundarios.' numero='4')
            .row.justify-content-center.align-items-star
              .col-12.col-lg-12.mb-4.mb-lg-0
                p.mb-3  Se identifican por el grado de influencia que ejercen en la organización de manera informal.


    .row.align-items-center.justify-content-center.mb-5
      .col-lg-7(data-aos="fade-right") 
        p.mb-3 A través del análisis estratégico de los grupos de interés, es posible identificar los tipos de participantes que lo integran, lo cual es fundamental para que la organización potencialice su existencia para su beneficio, de acuerdo con los objetivos que estos hayan trazado. Los participantes pueden pertenecer a diferentes grupos de interés dependiendo de sus objetivos, los cuales son momentáneos, por lo que se hace necesario realizar la valoración de los mismos para reconocerlos en función de su importancia y valorar los posibles impactos sobre los objetivos de la empresa. Esta valoración es posible realizarla gracias al mapeo de <i>stakeholders</i> o grupos de interés.

        p.mb-0 Es una representación gráfica del tipo de relación existente entre los grupos de interés y el proyecto u organización. Se elabora  con el fin de comprender los diversos niveles de influencia y su relevancia en la empresa. Asimismo, permite realizar monitoreo de la evolución de todas las relaciones a largo plazo y evidencia la influencia que los grupos de interés ejercen sobre la organización o que la empresa ejerce sobre ellos, tal como se presenta en la figura.
      .col-lg-5(data-aos="fade-left") 
        img.mt-3(src='@/assets/curso/images/tema2/img_10.png')
    .row.align-items-center.justify-content-center.mb-5
      .col-lg-6
        .titulo-sexto.color-acento-contenido.mb-3(data-aos="zoom-in-right")
          h5 Figura 11
          span Mapa de <i>stakeholders</i>
        img.mt-3(src='@/assets/curso/images/tema2/fig_5.svg')(data-aos="zoom-in-down")
    
    .row.aling.my-5   
      .col-lg-10(data-aos="zoom-in-down")
        .cajon.color-custom-1.p-4.mb-4.p-4
          .row.justify-content-around.align-items-center
            .col-lg-12
              .row.justify-content-between.align-items-center
                .col.mb-3.mb-sm-0
                  p.mb-0 Esta herramienta aparece gracias a que el nivel directivo de las organizaciones ha reconocido la importancia y tomado conciencia de administrar estratégica y proactivamente los grupos de interés.
    
    
    
    
  



   
</template>

<script>
export default {
  name: 'Tema2',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
